<template>
    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col>
                <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
                    <div>
                        <SportipsButton toPage="Administration" chevronLeft>Retour</SportipsButton>
                    </div>
                    <div>Cette interface vous permet de gérer la liste d'attente de la bourse aux dossards de {{
                        mainStore.module.nom }}.</div>
                    <div class="text-h6 font-weight-bold">Lien d'accès privé</div>
                    <div>Obtenir un lien d'accès privé universel pour la liste d'attente privé. En possession de ce
                        lien, un utilisateur pourra accéder à la liste d'attente privée de l'événement et s'inscrire
                        avec le mail de son choix.</div>
                    <div>
                        <SportipsButton @onClick="copyLatokenToClipboard" icon="mdi-content-copy" chevron>Lien d'accès
                            privé
                        </SportipsButton>
                    </div>

                    <ListeAttenteBourseSearchForm @refresh="refreshOverview"></ListeAttenteBourseSearchForm>

                    <ListeAttenteBourseOverview ref="overview"></ListeAttenteBourseOverview>



                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import ListeAttenteBourseSearchForm from "@/components/Administration/ListeAttenteBourse/SearchForm.vue";
import ListeAttenteBourseOverview from "@/components/Administration/ListeAttenteBourse/Overview.vue";
export default {
    name: 'ListeAttenteBourseAdmin',
    components: { ListeAttenteBourseSearchForm, ListeAttenteBourseOverview },
    computed: {
        ...mapStores(useMainStore),
    },
    methods: {
        refreshOverview() {
            if (this.$refs.overview && this.$refs.overview.fetchOverview) {
                this.$refs.overview.fetchOverview();
            }
        },
        copyLatokenToClipboard() {
            const base = this.mainStore.module.base;
            const url = window.location.origin + '/inscription/' + base + '/liste-attente?latoken=';
            const latoken = 'a0JmME5IZWFlV3dhbDEvRkhkVExJdz09';
            const fullUrl = url + latoken;
            navigator.clipboard.writeText(fullUrl);
            this.mainStore.notification.display = true;
            this.mainStore.notification.message = 'Lien d\'accès privé copié dans le presse-papiers';
            this.mainStore.notification.type = 'success';
        }
    }
}
</script>

<style lang="scss" scoped></style>